import { render, staticRenderFns } from "./manageEmployeeDocuments.vue?vue&type=template&id=0361fad7&scoped=true&lang=html"
import script from "./manageEmployeeDocuments.vue?vue&type=script&lang=js"
export * from "./manageEmployeeDocuments.vue?vue&type=script&lang=js"
import style0 from "./manageEmployeeDocuments.vue?vue&type=style&index=0&id=0361fad7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0361fad7",
  null
  
)

export default component.exports